import { useTranslation } from 'react-i18next';
import { barahMarkSrc } from '@barahpay/shared';

/**
 * The Barah Plus loader: the mark breathing inside a slowly turning ring, over a soft glow. Nothing is
 * painted for the first 200ms, so a screen that loads quickly never flickers a spinner.
 */
export function BarahLoader({ size = 'md', fullScreen = false }: { size?: 'sm' | 'md' | 'lg'; fullScreen?: boolean }) {
  const { t } = useTranslation();

  return (
    <div className={`barah-loader-shell${fullScreen ? ' barah-loader-shell--full' : ''}`} role="status">
      <div className={`barah-loader${size === 'md' ? '' : ` barah-loader--${size}`}`} aria-hidden>
        <span className="barah-loader__glow" />
        <svg className="barah-loader__ring" viewBox="0 0 100 100">
          <circle className="barah-loader__ring-track" cx="50" cy="50" r="48" />
          <circle className="barah-loader__ring-arc" cx="50" cy="50" r="48" pathLength={100} strokeDasharray="30 70" />
        </svg>
        <span className="barah-loader__mark">
          <img src={barahMarkSrc} alt="" />
        </span>
      </div>
      <span className="bp-sr-only">{t('common.loading')}</span>
    </div>
  );
}
